import { KeyboardEvent } from "react";

const ENTER_IS_TAKEN = ["textarea", "[role='combobox']", "[aria-expanded='true']", "button", "a[href]"].join(
  ",",
);

export const shouldConfirmOnEnter = (
  event: KeyboardEvent<HTMLElement>,
  { enabled, blocked }: { enabled: boolean; blocked: boolean },
): boolean => {
  if (!enabled || blocked) {
    return false;
  }

  if (event.key !== "Enter" || event.defaultPrevented) {
    return false;
  }

  const target = event.target as HTMLElement | null;

  return !target?.closest(ENTER_IS_TAKEN);
};

/** `#modal-container`, declared in `index.html`, is where every dialog portals to. */
export const getDialogPortalContainer = (): HTMLElement | undefined => {
  if (typeof document === "undefined") {
    return undefined;
  }

  return document.getElementById("modal-container") ?? undefined;
};

/** Stamped on the history entry a dialog pushes, so the dialog can tell its own entry from the router's. */
const DIALOG_HISTORY_KEY = "apolloDialogId";

export const dialogHistoryEntry = (dialogId: string) => ({ [DIALOG_HISTORY_KEY]: dialogId });

export const isDialogHistoryEntry = (state: unknown, dialogId: string): boolean =>
  typeof state === "object" &&
  state !== null &&
  (state as Record<string, unknown>)[DIALOG_HISTORY_KEY] === dialogId;
